import {PlatformNavbarMenuItem} from "@flexinet/ui-components";
import {
    AiOutlineAppstore,
    AiOutlineBook,
    AiOutlineBuild,
    AiOutlineCamera,
    AiOutlineCloudServer,
    AiOutlineCode,
    AiOutlineDashboard,
    AiOutlineDeploymentUnit,
    AiOutlineGroup,
    AiOutlineHome,
    AiOutlineLogin,
    AiOutlinePartition,
    AiOutlineSliders,
    AiOutlineThunderbolt,
    AiOutlineTool,
    AiOutlineWallet
} from 'react-icons/ai'
import {rbacActions} from "../../../config/rbac/actions";

export const getMenuItems = () => {
    return [
        {
            id: 'dashboard',
            link: '/dashboard',
            label: 'Dashboard',
            icon: <AiOutlineHome/>,
            rbac: rbacActions.ViewDashboard,
        }, {
            id: 'accounts',
            link: '/accounts',
            label: 'Accounts',
            icon: <AiOutlineWallet/>,
            rbac: rbacActions.ListAccounts,
        }, {
            id: 'users-group',
            link: '/users',
            label: 'Directory',
            icon: <AiOutlineGroup/>,
            rbac: 'ListUsers',
            defaultOpened: false,
            links: [{
                id: 'users',
                link: '/users',
                label: 'Users',
                icon: <AiOutlineLogin/>,
                rbac: rbacActions.ListUsers,
            }]
        }, {
            id: 'organizations',
            link: '/organizations',
            label: 'Organizations',
            icon: <AiOutlineCloudServer/>,
            rbac: rbacActions.ListOrganizations,
        }, {
            id: 'applications',
            link: '/applications',
            label: 'Applications',
            icon: <AiOutlineAppstore/>,
            rbac: rbacActions.ListApplications,
        }, {
            id: 'workflows-group',
            link: '/playbooks',
            label: 'Workflows',
            icon: <AiOutlinePartition/>,
            rbac: rbacActions.ListPlaybooks,
            defaultOpened: false,
            links: [{
                id: 'playbooks',
                link: '/playbooks',
                label: 'Playbooks',
                icon: <AiOutlineBook/>,
                rbac: rbacActions.ListPlaybooks,
            }, {
                id: 'executions',
                link: '/executions',
                label: 'Executions',
                icon: <AiOutlineThunderbolt/>,
                rbac: rbacActions.ListExecutions,
            }]
        }, {
            id: 'pipelines-group',
            link: '/pipelines',
            label: 'DevOps',
            icon: <AiOutlineBuild/>,
            rbac: rbacActions.ListPipelines,
            defaultOpened: false,
            links: [{
                id: 'pipelines',
                link: '/pipelines',
                label: 'Pipelines',
                icon: <AiOutlineBuild/>,
                rbac: rbacActions.ListPipelines,
            }, {
                id: 'code-pipelines',
                link: '/code-pipelines',
                label: 'Code Pipelines',
                icon: <AiOutlineDeploymentUnit/>,
                rbac: rbacActions.ListCodePipelines,
            }, {
                id: 'code-repositories',
                link: '/code-repositories',
                label: 'Repositories',
                icon: <AiOutlineCode/>,
                rbac: rbacActions.ListCodeRepositories,
            }, {
                id: 'deployment-account-groups',
                link: '/deployment-account-groups',
                label: 'Account Groups',
                icon: <AiOutlineGroup/>,
                rbac: rbacActions.ListDeploymentAccountGroups,
            }]
        }, {
            id: 'application-screenshots-group',
            link: '/application-screenshots',
            label: 'Tools',
            icon: <AiOutlineTool/>,
            rbac: rbacActions.ListApplicationScreenshots,
            defaultOpened: false,
            links: [{
                id: 'application-screenshots',
                link: '/application-screenshots',
                label: 'Screenshots',
                icon: <AiOutlineCamera/>,
                rbac: rbacActions.ListApplicationScreenshots,
            }]
        },
        {
            // FNP-891 / FNP-893: platform-wide operational controls. Top-level and
            // always present — the whole point of this module is that the controls
            // (including the ones not wired up yet) are visible rather than living
            // only in a parameter store nobody remembers.
            id: 'platform-controls',
            link: '/platform-controls',
            label: 'Platform Controls',
            icon: <AiOutlineSliders/>,
            rbac: rbacActions.ListPlatformControls,
        }, {
            id: 'analytics',
            link: '/analytics',
            label: 'Analytics',
            icon: <AiOutlineDashboard/>,
            rbac: rbacActions.ListUsers,
        }] as PlatformNavbarMenuItem[];

};
